import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";
import { SanitizeHtml, getAccessSettings } from "../Shared/Utility";
import * as XLSX from "xlsx";
export default function IBBDepartment() {
  
  const globalState = useGlobalState();
  const [DepartmentGridData, setDepartmentGridData] = useState([]);
  const [DepartmentUserGridData, setDepartmentUserGridData] = useState([]);
  const [UserList, setUserList] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  {
    /*MM:: 1 means grid view.. 2 means add view and 3 means edit view*/
  }

  const [DepartmentData, setDepartmentData] = useState({}) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    IBBDepartmentGetCompleteGridDataCustom();
    IBBDepartmentUserGetCompleteGridDataCustom(0);
  }, []);

  function IBBDepartmentGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartment/IBBDepartmentGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setDepartmentGridData(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBDepartmentSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdepartmentid = DepartmentData.IBBDepartmentID;
    object.name = SanitizeHtml(DepartmentData.Name);
    object.description = DepartmentData.Description;
    object.selectedusers = DepartmentData.SelectedUsers;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBDepartment/IBBDepartmentSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          IBBDepartmentGetCompleteGridDataCustom();
          setCurrentView(1);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBDepartmentDeleteRecordCustom(IBBDepartmentID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdepartmentid = IBBDepartmentID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartment/IBBDepartmentDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBDepartmentGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  
  function IBBDepartmentUserGetCompleteGridDataCustom(IBBDepartmentID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdepartmentid = IBBDepartmentID;
    object.recordsperpage = 100;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartmentUser/IBBDepartmentUserGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setDepartmentUserGridData(result[1]);
          setUserList(result[2]);
          checkUserAlreadyInGroup(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBDepartmentUserSaveCustom(
    IBBDepartmentUserID: number,
    IBBDepartmentID: number,
    AssignedUserID: number,
    IsDeleted: boolean,
    UserCount: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbdepartmentuserid = IBBDepartmentUserID;
    object.ibbdepartmentid = IBBDepartmentID;
    object.assigneduserid = AssignedUserID;
    object.isdeleted = IsDeleted;
    object.usercount = UserCount;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartmentUser/IBBDepartmentUserSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function checkUserAlreadyInGroup(DepartmentUserGridDataParam: any) {
    let UserListLocal = [...UserList] as any;
    for (let i = 0; i < UserListLocal.length; i++) {
      let SiteUserID = UserListLocal[i].PID;
      var filtered = DepartmentUserGridDataParam.filter(
        (item: any) => item.AssignedUserID == SiteUserID
      );
      if (filtered.length > 0) {
        UserListLocal[i].IBBDepartmentUserID =
          filtered[0].IBBDepartmentUserID;
          UserListLocal[i].IsChecked = true;
          UserListLocal[i].IsDeleted = false;
      } else {
        UserListLocal[i].IsChecked = false;
        UserListLocal[i].IsDeleted = true;
      }
    }
    if (UserListLocal.length > 0)
      setUserList(UserListLocal);
  }

  function updateUserListInGroup(index: number, type: number, value: any) {
    let UserListLocal = [...UserList] as any;
    if (type == 1) {
      UserListLocal[index].IsChecked = value;
      UserListLocal[index].IsDeleted = !value;
    }

    let selectedUsers = "";
    var filtered = UserListLocal.filter(
      (item: any) => item.IsChecked == true
    );

    for (let i = 0; i < filtered.length; i++) {
      if (selectedUsers == "") selectedUsers = filtered[i].PID;
      else selectedUsers += "," + filtered[i].PID;
    }

    setDepartmentData((prevState: any) => ({
      ...prevState,
      SelectedUsers: selectedUsers,
    }));

    if (DepartmentData.IBBDepartmentID > 0) {
      IBBDepartmentUserSaveCustom(
        UserListLocal[index].IBBDepartmentUserID,
        DepartmentData.IBBDepartmentID,
        UserListLocal[index].PID,
        UserListLocal[index].IsDeleted,
        filtered.length
      );
    }

    setUserList(UserListLocal);
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBDepartmentDeleteRecordCustom(obj.SelectedID)
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID:0
    });
  }

    // Download in Excel function
    function DownloadClientsDataInExcel(id: any, name: any) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
        document.getElementById(id)
      );
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, name);
  
      XLSX.writeFile(wb, name + ".xlsx");
    }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Function List</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <span></span>
              <div className="flex-items">
              {getAccessSettings(2, 21) > 1 &&  <a
                className="btn-link"
                onClick={() => {
                  setDepartmentData({});
                  setDepartmentUserGridData([]);
                  checkUserAlreadyInGroup([]);
                  setCurrentView(2);
                  setCanEdit(true);
                }}
              >
                Add Function
              </a>}

              <a
              className="btn-primary "
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblFunctionList",
                  "FunctionList"
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>


            </div>
            </div>
            <div className="section-table">
              <table className="part-head trend-table fixed-table" id="tblFunctionList">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Users #</th>
                    <th className="md-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {DepartmentGridData &&
                    DepartmentGridData.map((item: any, index: any) => (
                      <React.Fragment key={"Department" + index}>
                        <tr>
                          <td>{item.Name}</td>
                          <td className="text-right">{item.Description}</td>
                          <td className="md-col">
                            <div
                              className="width-100 text-center btn-sm-grid"
                              style={{ justifyContent: "flex-start" }}
                            >
                            {getAccessSettings(2, 21) > 1 &&   <a
                                className="btn-primary btn-grid"
                                onClick={() => {
                                  IBBDepartmentUserGetCompleteGridDataCustom(item.IBBDepartmentID);
                                  setCurrentView(3);
                                  setDepartmentData(item);
                                }}
                                title={"View/Edit Details"}
                              >
                                <img
                                  src="images/edit.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>}
                              {/* <a
                                className="btn-primary btn-grid"
                                // onClick={() => {
                                //   IBBDepartmentDeleteRecordCustom(
                                //     item.IBBDepartmentID
                                //   );
                                // }}
                                onClick={() => {
                                  globalState.setConfirmationObject({
                                    ShowPopup: true,
                                    Heading: "Confirmation ",
                                    Message: "Are you sure you want to delete this record?",
                                    ID: 1,
                                    SelectedID:item.IBBDepartmentID
                                  });
                                }}
                                title="Delete"
                              >
                                <img
                                  src="images/delete.svg"
                                  width={15}
                                  height={15}
                                />
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(currentView == 2 || currentView == 3 || currentView == 4) && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Function</a>}
            {currentView == 3 && canEdit && <a>Edit Function</a>}
            {!canEdit && <a>Function Details</a>}
          </div>
          <div className="page--data">
              <div className="program-form form-group">
                <div className="form-item">
                  <span>Name:</span>
                  <input
                    type="text"
                    value={DepartmentData.Name}
                    onChange={(e) =>
                      setDepartmentData((prevState: any) => ({
                        ...prevState,
                        Name: e.target.value,
                      }))
                    }
                  ></input>
                </div>
                <div className="form-item form-top">
                  <span>Users:</span>
                  <div className="flex-check-importers">
                    {UserList &&
                      UserList.map((item: any, index: any) => (
                        <React.Fragment key={"userlist" + index}>
                          <div className="flex-check-inner">
                          {item.IsChecked}
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={item.IsChecked}
                              onChange={(e) =>
                                updateUserListInGroup(
                                  index,
                                  1,
                                  !item.IsChecked
                                )
                              }
                            />
                            <span>{item.Name}
                              {/* {item.Name}&nbsp;[{item.Email}] */}
                            </span>
                          </div>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
                <div className="form-btns">
                  <a onClick={IBBDepartmentSaveCustom}>Save</a>
                  <a
                    onClick={() => {
                      setCurrentView(1);
                      IBBDepartmentGetCompleteGridDataCustom();
                    }}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
